// ipserver.js

// home 192.168.1.63
// office 172.16.1.56
// mbtm.thaigl.com


//const ip = '172.16.1.56:5000';
const ip = 'mbtm.thaigl.com';
// สำหรับ server
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ip;
} 

// สำหรับ client
if (typeof window !== 'undefined') {
    window.Ipserver = ip;
}

